import {FormattedDate} from 'react-intl-next';

const DefaultFormattedDate = FormattedDate;

DefaultFormattedDate.defaultProps  = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
};

export default DefaultFormattedDate;
